import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LeadDetail from "./LeadDetail";
import LeadDeals from "./LeadDeals";
import LeadHistory from "./LeadHistory";
import LeadNotesHistory from "./LeadNotesHistory";
import LeadDbService from "../../Services/LeadDbService";
import { ToastContainer, toast } from "react-toastify";
import { BsFire } from "react-icons/bs";
import HotLeadHistoryModel from "../../HotLeadComponent/HotLeadHistoryModel";
import { userRole, userUid } from "../../../utils/storage";
import { getBasePathByUserRole } from "../../../utils/roleRoutes";
import CustomHeading from "../../common/CustomHeading";
import useScrollToTop from "../../../hooks/useScrollToTop";
import { showInfoToast, showSuccessToast, showWarningToast } from "../../Constant/Notification";
import HotLeadService from "../../Services/HotLeadService";
import  Loader  from "../../Constant/Loader";

const LeadInfo = () => {
  const navigate = useNavigate();
  const { leadId } = useParams();
  const location = useLocation();

  const [leadTeamName, setLeadTeamName] = useState("");
  const [leadUserName, setLeadUserName] = useState("");
  const [assignedUserId, setAssignedUserId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [leadHotHistoryData, setLeadHotHistoryData] = useState([]);
  const [isEdit, setIsEdit] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const tabs = ["Basic Info", "More Info"];
  const leadAssignStatus = location?.state?.assignStatus;
  const [loading , setLoading] = useState(false);

  const [leadInfo, setLeadInfo] = useState({
    leadId: "",
    name: "",
    phoneNumber: "",
    countryCode: "",
    emailId: "",
    leadQuality: { label: "", value: "" },
    leadCharacter: { label: "", value: "" },
    assignedTeam: "",
    assignedUser: "",
    leadSource: { label: "", value: ""  },
    createdTime: "",
    interestTags: [],
    interestedLocations: [],
    status: { label: "", value: "" },
    clientLocation: "",
    clientPurpose: "",
    clientJobOrBusiness: "",
    clientResidentialDetails: "",
    clientRequirement: "",
    paymentType: "",
    notes: "",
    uploadedBy: "",
    teamId: "",
    assignedUserId: "",
    interestedCategory: { label: "", value: "" },
    interestedProperty: { label: "", value: "" },
    isManagement : false,
  });

  const handleLeadHotHistory = async (leadId) => {
    setIsOpen(true);
    try {
      const response = await HotLeadService.getHotLeadHistory(leadId);
      if (response.status === 200) {
        setLeadHotHistoryData(response.data?.history || []);
      }
    } catch (error) {
      console.error("Error fetching hot lead history:", error);
     
    }
  };

  console.log("leadSource ", leadInfo.leadSource);  

  const handleReassign = () => {
    const path = getBasePathByUserRole();
    if (leadInfo.status.label === "Dealing" || leadInfo.status.label === "Registered Client") {
      showInfoToast("Cannot reassign lead when it is in Dealing or Registered Client status.");
      return;
    }
    navigate(`${path}/lead/reassign`, {
      state: {
        leadTeam: leadTeamName,
        teamId: leadInfo.teamId,
        leadUser: leadUserName,
        leadId: leadId,
        memberId: assignedUserId,
      },
    });
  };

  const handleAssign = () => {
    const path = getBasePathByUserRole();
    navigate(`${path}/lead/reassign`, {
      state: {
        leadSourceId: leadInfo.leadSource?.value,
        assignStatus: true,
        leadCount: 1,
        teamId: leadInfo.teamId,
        leadIds: [leadId],
      },
    });
  };

  const fetchData = async () => {
    try {
      const response = await LeadDbService.fetchLeadById(leadId);
      const leadData = response.data;
      setLeadInfo({
        leadId: leadData.docId || "",
        name: leadData.name || "",
        phoneNumber: leadData.phoneNumber || "",
        countryCode: leadData.countryCode || "",
        emailId: leadData.emailId || "",
        leadQuality: leadData.leadQuality || { label: "", value: "" },
        leadCharacter: leadData.leadCharacter || { label: "", value: "" },
        leadSource: leadData.leadSource || { label: "", value: ""  },
        assignedTeam: leadData.assignedTeam || "",
        assignedUser: leadData.assignedUser || "",
        createdTime: leadData.createdTime || "",
        interestTags: leadData.interestTags || [],
        interestedLocations: leadData.interestedLocations || [],
        status: leadData.status || { label: "", value: "" },
        clientLocation: leadData.clientLocation || "",
        clientPurpose: leadData.clientPurpose || "",
        clientJobOrBusiness: leadData.clientJobOrBusiness || "",
        clientResidentialDetails: leadData.clientResidentialDetails || "",
        clientRequirement: leadData.clientRequirement || "",
        paymentType: leadData.paymentType || "",
        notes: leadData.notes || "",
        teamId: leadData.teamId || "",
        assignedUserId: leadData.assignedUserId || "",
        uploadedBy: leadData.uploadedBy || "",
        interestedCategory: {
          label: leadData.interestedCategory?.label || leadData.interestedCategory?.lable || "",
          value: leadData.interestedCategory?.value || "",
        },
        interestedProperty: {
          label: leadData.interestedProperty?.label || leadData.interestedProperty?.lable || "",
          value: leadData.interestedProperty?.value || "",
        },
        isManagement : leadData.isManagement || false,
      });
      setLeadTeamName(leadData.assignedTeam || "");
      setLeadUserName(leadData.assignedUser || "");
      setAssignedUserId(leadData.assignedUserId || "");
    } catch (error) {
      console.error("Error fetching lead data:", error);
      
    }
  };

  useEffect(() => {
    fetchData();
  }, [leadId]);

  useEffect(() => {
    if (location.state?.message) {
      showSuccessToast(location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  useScrollToTop();

  const handleEditLeadInfo = async () => {

    if (!isEdit) {
      const phone = leadInfo.phoneNumber.trim();
      const name = leadInfo.name.trim();
  
      if (!phone) {
        showWarningToast("Please enter phone number");
        return;
      }
  
      if (phone.length !== 10) {
        showWarningToast("Phone number must be exactly 10 digits");
        return;
      }
  
      if (!/^\d{10}$/.test(phone)) {
        showWarningToast("Phone number must contain only digits");
        return;
      }
  
      if (!name) {
        showWarningToast("Please enter name");
        return;
      }

      setLoading(true)
  
      const updatedLeadInfo = {
        docId: leadId,
        name: leadInfo.name || null,
        phoneNumber: leadInfo.phoneNumber || null,
        countryCode: leadInfo.countryCode || null,
        emailId: leadInfo.emailId || null,
        leadQuality: leadInfo.leadQuality?.value || null,
        leadCharacter: leadInfo.leadCharacter?.value || null,
        leadSource: leadInfo.leadSource?.value || null,
        interestedTags: leadInfo.interestTags?.map((tag) => tag.value) || [],
        interestedLocations: leadInfo.interestedLocations?.map((loc) => loc.value) || [],
        status: leadInfo.status?.value || null,
        clientLocation: leadInfo.clientLocation || null,
        clientPurpose: leadInfo.clientPurpose || null,
        clientJobOrBusiness: leadInfo.clientJobOrBusiness || null,
        clientResidentialDetails: leadInfo.clientResidentialDetails || null,
        clientRequirement: leadInfo.clientRequirement || null,
        paymentType: leadInfo.paymentType || null,
        notes: leadInfo.notes || null,
        modifiedBy: userUid,
        uploadedBy: leadInfo.uploadedBy || null,
        interestedCategoryId: leadInfo.interestedCategory?.value || null,
        interestedPropertyId: leadInfo.interestedProperty?.value || null,
        sourceType : leadInfo.isManagement || false
      };
      try {
        const response = await LeadDbService.leadInfoUpdate(updatedLeadInfo);
        if (response.status === 200) {
          showSuccessToast(response.data.message || "Lead updated successfully");
         
          await fetchData(); 
        } 
      } catch (error) {
        console.error("Error updating lead:", error);
        toast.error("Error updating lead. Please try again.", { position: "top-center" });
      }finally{
        setLoading(false)
      }
    }
    setIsEdit(!isEdit);
  };

  return (
    <div className="bg-appGrayBackground">
      <AdminAppBar />
      <ToastContainer position="top-center" theme="light" />

      {loading && (
        <Loader/>
      )}
      <div className="h-full py-28 px-6">
        <div className="flex pt-2 items-center">
          <div className="flex justify-between w-full">
            <CustomHeading title="Lead Info" isIcon={true} />
            <div className="flex items-center gap-4">
       {/* {(userRole === "Admin" || userRole === "CMO") && (
                <div
                  onClick={() => handleLeadHotHistory(leadId)}
                  className="bg-white cursor-pointer flex items-center justify-center gap-2 text-base text-[#EE6C4D] font-medium w-full rounded-[10px] p-2"
                >
                  <BsFire className="text-xl" />
                  <div>Hot Lead History</div>
                </div>
              )}  */}
             {(userRole === "Admin" || userRole === "CMO") &&(
              <>
               {activeTab === 0 && (
                <div
                  onClick={handleEditLeadInfo}
                  className="bg-customGreen cursor-pointer text-white rounded-[10px] px-4 py-2"
                >
                  {isEdit ? "Edit" : "Update"}
                </div>
              )}
              </>
             )}
              {leadInfo.assignedUser !== "Unassigned" &&
                ["Admin", "CMO", "BOD"].includes(userRole || "") && (
                  <button
                    onClick={handleReassign}
                    className={`h-10 ${
                      leadInfo.status.label === "Dealing" || leadInfo.status.label === "Registered Client"
                        ? "bg-gray-500"
                        : "bg-customGreen"
                    } cursor-pointer text-white p-2 rounded-[10px] mr-12`}
                  >
                    Reassign
                  </button>
                )}
              {leadInfo.assignedUser === "Unassigned" &&
                ["Admin", "CMO", "BOD"].includes(userRole || "") && (
                  <button
                    onClick={handleAssign}
                    className={`h-10 ${
                      leadInfo.status.label === "Dealing" ? "bg-gray-500" : "bg-customGreen"
                    } cursor-pointer text-white p-2 rounded-[10px] mr-12`}
                  >
                    Assign
                  </button>
                )}
            </div>
          </div>
        </div>
        <div className="bg-white rounded-[10px] p-6 mt-4">
          <div>
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`text-xl px-4 py-2 focus:outline-none ${
                  activeTab === index
                    ? "border-b-4 border-customGreen text-customGreen"
                    : "text-gray-500 hover:text-customGreen"
                }`}
                onClick={() => setActiveTab(index)}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className="px-4 mt-7 gap-12 xl:gap-5">
            {activeTab === 0 ? (
              <LeadDetail isEdit={isEdit} lead={leadInfo} setLeadInfo={setLeadInfo} leadInfo={leadInfo} />
            ) : (
              <div className="grid grid-cols-2 gap-5">
                <LeadDeals docId={leadId} />
                <LeadHistory docId={leadId} />
                <LeadNotesHistory docId={leadId} />
              </div>
            )}
          </div>
        </div>
      </div>
      <HotLeadHistoryModel
        isOpen={isOpen}
        selectedLeaddata={leadHotHistoryData}
        isClose={() => setIsOpen(false)}
      />
    </div>
  );
};

export default LeadInfo;